"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    integrations: {
        path: "/settings/data/integrations",
    },
    arcGISExports: {
        path: "/settings/data/integrations/arcgis",
    },
    accela: {
        path: "/settings/data/integrations/accela",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZWdyYXRpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vcm91dGluZy9pbnRlZ3JhdGlvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQXNDO0FBRXpCLFFBQUEsTUFBTSxHQUFHLElBQUEsbUJBQVcsRUFBQztJQUNoQyxZQUFZLEVBQUU7UUFDWixJQUFJLEVBQUUsNkJBQTZCO0tBQ3BDO0lBQ0QsYUFBYSxFQUFFO1FBQ2IsSUFBSSxFQUFFLG9DQUFvQztLQUMzQztJQUNELE1BQU0sRUFBRTtRQUNOLElBQUksRUFBRSxvQ0FBb0M7S0FDM0M7Q0FDRixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIGludGVncmF0aW9uczoge1xuICAgIHBhdGg6IFwiL3NldHRpbmdzL2RhdGEvaW50ZWdyYXRpb25zXCIsXG4gIH0sXG4gIGFyY0dJU0V4cG9ydHM6IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5ncy9kYXRhL2ludGVncmF0aW9ucy9hcmNnaXNcIixcbiAgfSxcbiAgYWNjZWxhOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvZGF0YS9pbnRlZ3JhdGlvbnMvYWNjZWxhXCIsXG4gIH0sXG59KTtcbiJdfQ==